import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function MembersByMonth ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const membersByMonth = [
    ['Mês', 'Demais membros', 'Novos membros'],
    ...Object.entries (data).map (([month, values]) => [
      month,
      Number (values.total) || 0,
      Number (values.new) || 0
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Membros por mês</SubTitle>
      <ColumnChart
        data={membersByMonth}
        legendPosition='top'
        options={{
          height: 350,
          colors: ['#FFC100', '#35A7FF', '#44CF6C'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Membros',
            minValue: 0,
            titleTextStyle: { bold: true }
          }
        }}
      />
    </InfoContainer>
  )
}
